import { Component } from '@angular/core';
import { AbstractFieldDirective } from '../abstract-field.directive';
import { toNumberValue } from '../../tool/field.function';

@Component({
  selector: 'app-number-field',
  templateUrl: './number-field.component.html',
  styleUrls: ['./number-field.component.scss']
})
export class NumberFieldComponent extends AbstractFieldDirective {

  protected get value(): undefined | number {
    return this.parseNumber(this.field?.value);
  }

  protected get minValue(): undefined | number {
    return this.parseNumber(this.field?.minValue);
  }
  protected get maxValue(): undefined | number {
    return this.parseNumber(this.field?.maxValue);
  }

  protected updateValue(value?: null | number): void {
    if (!this.field)
      return;
    const newValue = toNumberValue(value);
    if (this.field.value === newValue)
      return;
    this.field.value = newValue;
    this.fieldChange.emit(this.field);
  }

  protected updateMinValue(value?: null | number): void {
    if (!this.field)
      return;
    const minValue = toNumberValue(value);
    if (this.field.minValue === minValue)
      return;
    this.field.minValue = minValue;
    this.fieldChange.emit(this.field);
  }
  protected updateMaxValue(value?: null | number): void {
    if (!this.field)
      return;
    const maxValue = toNumberValue(value);
    if (this.field.maxValue === maxValue)
      return;
    this.field.maxValue = maxValue;
    this.fieldChange.emit(this.field);
  }

  protected get error(): string {
    if (this.value === undefined)
      return '';
    if (!this.value && !this.required)
      return '';
    if (this.minValue !== undefined && this.value < this.minValue)
      return `La valeur doit être supérieure ou égale à ${this.minValue}.`;
    if (this.maxValue !== undefined && this.value > this.maxValue)
      return `La valeur doit être inférieure ou égale à ${this.maxValue}.`;
    return '';
  }

  private parseNumber(value?: null | string): undefined | number {
    return value ? Number(value) : undefined;
  }

}
